<ng-template>
    <ngx-skeleton-loader *ngIf="isLoading" count="5"
                         [theme]="{ width: '200px', height: '200px' }"></ngx-skeleton-loader>
</ng-template>
<div *ngIf="!isLoading">
    <div *ngFor="let item of data | keyvalue">
        <a class="card-text text-muted font-small-2">{{ item.value.name }} : {{ item.value.nc }}</a>
    </div>
</div>
